import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../graphql/API';
import { onChatClosed } from '../../graphql/subscriptions';
import { processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

type Props = {
  userId?: string;
};

export const useAdminCloseChatListener = ({ userId }: Props) => {
  const [closeMessage, setCloseMessage] = React.useState<Nullable<ChatMessageItem>>(null);

  React.useEffect(() => {
    const createSub = client.graphql({
      query: onChatClosed,
      variables: { userType: 'venue', toUserId: userId as string },
    }).subscribe({
      next: ({ data }: { data: { onChatClosed: ChatMessageItem } }) => {
        const _message = processGqlResult<ChatMessageItem>('onChatClosed', { data });
        setCloseMessage(_message as ChatMessageItem);
      },
      error: (error) => {
        console.warn(error);
      },
    });

    return () => {
      createSub.unsubscribe();
    };
  }, [setCloseMessage, userId]);

  return {
    closeMessage,
  };
};
